import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const MintingPopup = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, height: "auto", transition: { duration: 0 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <MintLoader>
        <div className="s">
          <div className="container">
            <div className="popupCard">
              <div className="wrapperYelloe" style={{ overflow: "hidden" }}>
                <div className="yellowFade pos"></div>
              </div>
              <div className="popupWrapperBox">
                <div className="subhead mar">
                  Sit back and relax!<br></br> This might take few seconds!
                </div>
                <div className="img">
                <div className="loader">
                <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_618_4553" fill="white">
                <path d="M80.0964 42C82.2523 42 84.0188 43.7516 83.8188 45.8982C83.0437 54.2139 79.8022 62.1429 74.4664 68.6445C68.3021 76.1558 59.724 81.2973 50.1938 83.193C40.6636 85.0887 30.7709 83.6212 22.2013 79.0407C13.6318 74.4602 6.91557 67.05 3.19706 58.0727C-0.521445 49.0954 -1.01217 39.1066 1.8085 29.808C4.62918 20.5095 10.5867 12.4767 18.666 7.07828C26.7454 1.67985 36.4466 -0.750183 46.1167 0.202241C54.487 1.02664 62.3858 4.34114 68.8139 9.67324C70.4732 11.0496 70.4627 13.5373 68.9382 15.0618C67.4138 16.5862 64.9544 16.5659 63.2663 15.225C58.1381 11.1518 51.9233 8.61906 45.3515 7.97179C37.4789 7.19641 29.581 9.17473 23.0035 13.5697C16.426 17.9646 11.5758 24.5043 9.27948 32.0743C6.98312 39.6444 7.38263 47.7765 10.4099 55.085C13.4372 62.3936 18.905 68.4263 25.8816 72.1554C32.8582 75.8845 40.912 77.0791 48.6707 75.5359C56.4294 73.9925 63.4129 69.8068 68.4314 63.6917C72.6207 58.587 75.2243 52.4016 75.9703 45.8953C76.2159 43.7534 77.9405 42 80.0964 42Z"/>
                </mask>
                <path d="M80.0964 42C82.2523 42 84.0188 43.7516 83.8188 45.8982C83.0437 54.2139 79.8022 62.1429 74.4664 68.6445C68.3021 76.1558 59.724 81.2973 50.1938 83.193C40.6636 85.0887 30.7709 83.6212 22.2013 79.0407C13.6318 74.4602 6.91557 67.05 3.19706 58.0727C-0.521445 49.0954 -1.01217 39.1066 1.8085 29.808C4.62918 20.5095 10.5867 12.4767 18.666 7.07828C26.7454 1.67985 36.4466 -0.750183 46.1167 0.202241C54.487 1.02664 62.3858 4.34114 68.8139 9.67324C70.4732 11.0496 70.4627 13.5373 68.9382 15.0618C67.4138 16.5862 64.9544 16.5659 63.2663 15.225C58.1381 11.1518 51.9233 8.61906 45.3515 7.97179C37.4789 7.19641 29.581 9.17473 23.0035 13.5697C16.426 17.9646 11.5758 24.5043 9.27948 32.0743C6.98312 39.6444 7.38263 47.7765 10.4099 55.085C13.4372 62.3936 18.905 68.4263 25.8816 72.1554C32.8582 75.8845 40.912 77.0791 48.6707 75.5359C56.4294 73.9925 63.4129 69.8068 68.4314 63.6917C72.6207 58.587 75.2243 52.4016 75.9703 45.8953C76.2159 43.7534 77.9405 42 80.0964 42Z" stroke="url(#paint0_linear_618_4553)" strokeWidth="58.5" mask="url(#path-1-inside-1_618_4553)"/>
                <defs>
                <linearGradient id="paint0_linear_618_4553" x1="77.3043" y1="27.087" x2="109.261" y2="49.3043" gradientUnits="userSpaceOnUse">
                <stop stopColor="#CB4B35"/>
                <stop offset="1" stopColor="#CB4B35" stopOpacity="0.01"/>
                </linearGradient>
                </defs>
                </svg>
                </div>
                
                </div>

              
              </div>
            </div>{" "}
          </div>{" "}
        </div>
      </MintLoader>
    </motion.div>
  );
};
const MintLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  .s {
    width: 100%;
  }
  .closeBtn {
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
  }
  .wrapperYelloe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .img {
    position: relative;
    z-index: 2;
    margin-top: 90px;

    img {
      width: 300px;
    }
  }
  .mar {
    position: relative;
    z-index: 2;
    line-height: 120%;

    margin-bottom: 10px;
  }
  .SliderProgras {
    margin-top: 80px;
    width: 780px;
    height: 30px;

    background: rgba(217, 217, 217, 0.1);
    border: 1.19766px solid #c4c4c4;
    border-radius: 50px;

    .track {
      width: 50%;
      height: 100%;
      border-radius: 50px;

      background-color: #c73a33;
      display: flex;
      justify-content: end;
      align-items: center;
      position: relative;
      .ball {
        img {
          width: 100%;
        }

        position: absolute;
        right: -40px;
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
    }
  }
  .loader {
 
  
 border-radius: 50%;
 width: 84px;
 height: 84px;
 -webkit-animation: spin 2s linear infinite; /* Safari */
 animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
 0% { -webkit-transform: rotate(0deg); }
 100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
}
  .popupCard {
    min-height: 70vh;
    overflow: hidden;
    background: rgba(37, 37, 37, 0.9);
    border: 1px solid #c4c4c4;
    backdrop-filter: blur(10px);
    /* Note: backdrop-filter has minimal browser support */
    position: relative;
    border-radius: 24px;
    width: inherit;
  }
  .popupWrapperBox {
    padding: 70px 60px;
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;
  }
  .notNowBtn {
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 28px;
    text-decoration: underline;
    cursor: pointer;
  }
  @media screen and (max-width: 1350px) {
    .img {
      position: relative;
      z-index: 2;

      img {
        width: 200px;
      }
    }
    .SliderProgras {
      margin-top: 60px;
      width: 780px;
      height: 20px;

      background: rgba(217, 217, 217, 0.1);
      border: 1.19766px solid #c4c4c4;
      border-radius: 50px;

      .track {
        width: 50%;
        height: 100%;
        border-radius: 50px;

        background-color: #c73a33;
        display: flex;
        justify-content: end;
        align-items: center;
        position: relative;
        .ball {
          img {
            width: 100%;
          }

          position: absolute;
          right: -40px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 60px 0;
    .popupWrapperBox {
      padding: 70px 20px;
    }

    .img {
      margin-top: 30px;
      img {
        width: 270px;
      }
    }

    .SliderProgras {
      margin-top: 80px;
      width: 100%;
      height: 14px;

      background: rgba(217, 217, 217, 0.1);
      border: 1.19766px solid #c4c4c4;
      border-radius: 50px;

      .track {
        width: 50%;
        height: 100%;
        border-radius: 50px;

        background-color: #c73a33;
        display: flex;
        justify-content: end;
        align-items: center;
        position: relative;
        .ball {
          img {
            width: 100%;
          }

          position: absolute;
          right: -40px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }
    }
  }
`;

export default MintingPopup;
